import { numberToBRL } from "~/utils/number";

// "Dr(a). " só quando o nome ainda não traz o tratamento (Dr., Dra., Dr(a).); "Drummond" não conta.
const TITLE = /^dr(a|\(a\))?(\.|\s)/i;
const doctorLabel = (name) => {
  const trimmed = name?.trim();
  if (!trimmed) return null;
  return TITLE.test(trimmed) ? trimmed : `Dr(a). ${trimmed}`;
};

// Contexto padrão dos modais de pacote (Q3/Q12/G1.3: "Pacote #4821 · Dr(a). Marina · R$ 8.420,00").
export const packageContext = (row) =>
  [`Pacote #${row.id}`, doctorLabel(row.doctor_name), row.total_pay_value != null ? numberToBRL(row.total_pay_value) : null]
    .filter(Boolean)
    .join(" · ");
